import { render } from "./new_story_button.vue?vue&type=template&id=bc625b38&scoped=true&lang=pug"
import script from "./new_story_button.vue?vue&type=script&lang=js"
export * from "./new_story_button.vue?vue&type=script&lang=js"

import "./new_story_button.vue?vue&type=style&index=0&id=bc625b38&lang=scss&scoped=true"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc625b38"]])

export default __exports__